/**
 * API CompagnonCPS
 * API pour le connecteur CompagnonCPS
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreationPrescriptionPrescriptionsInnerCONTENUPRESCRIPTIONLIGDISPOSITIFMEDICALInner { 
    /**
     * EF_EP407.09 Code ACL sur 13 chiffres (1) (3) .
     */
    CodeACL?: string;
    /**
     * EF_EP407.03 Code LPP à 7 chiffres Il est recommandé demandé d’alimenter cette donnée si l’information est disponible(1)
     */
    CodeLPP?: string;
    /**
     * EF_EP407.12 Correspond au code GTIN
     */
    CodeREF13?: string;
    /**
     * EF_EP407.13 Donnée alimentée par le LPS
     */
    CodeUDI?: string;
    DCM?: string;
    DureeLocationLPP?: number;
    /**
     * EF_EP409.04 Donnée alimentée par le PS ou le LPS(1).
     */
    EstEnRapportALD?: boolean;
    /**
     * EF_EP409.05 Donnée alimentée par le PS ou le LPS(1).
     */
    EstEnRapportAccident?: boolean;
    /**
     * EF_EP409.06 Donnée alimentée par le PS ou le LPS(1).
     */
    EstEnRapportPrev?: boolean;
    /**
     * EF_EP409.07 Non remboursable. Donnée alimentée par le PS ou le LPS(1).
     */
    EstNonRemb?: boolean;
    LibelleLPPLibre?: string;
    LibelleMarque?: string;
    NbConditionnement?: number;
    /**
     * EF_EP409.03 Nombre de renouvellement. L’absence de renouvellement est indiquée par la valeur « 0 » (zéro).
     */
    NbRenouv?: number;
    NumLigne?: number;
}

